import React, { useEffect, useMemo, useState } from 'react';
import { Empty, Input, List, Row } from 'antd';
import { AbsoluteLoading, LoadingSpinner2 } from '@gtintel/platform-atoms';
import { PROJECT_STATUS_DISPLAY } from '@gtintel/platform-constants';
import { PartnerProposalStatus } from '@gtintel/platform-types';
import PartnerCard from '../PartnerCard';
import styles from './styles.module.scss';
function sortPartnersByNumberOfMatchedTags(partners, projectTags) {
  const projectTagIds = projectTags.map(({
    id
  }) => id);
  const partnersWithMatchCount = partners.map(partner => {
    const partnerTags = partner.tags ?? [];
    const matchedTags = partnerTags.filter(({
      id
    }) => projectTagIds.includes(id));
    return [partner, matchedTags.length];
  });
  partnersWithMatchCount.sort((a, b) => b[1] - a[1]);
  return partnersWithMatchCount.map(tuple => tuple[0]);
}
const RightPane = ({
  handleSearchPartner,
  updateSearchPartnerInput,
  handleSelectPartner,
  isActivated,
  loadingPartner,
  openPartnerModal,
  partnerData,
  projectDetail,
  searchPartner,
  selectingPartner,
  unMatchPartner
}) => {
  const [partnerList, setPartnerList] = useState([]);
  const [loadingState] = useState(false);
  const projectTags = projectDetail.tags ?? [];

  // Get partners who are tagged with at least one of the project's tags
  const suggestedPartners = useMemo(() => {
    const tagNames = projectTags.map(tag => tag.name);
    return partnerData.filter(partner => partner.tags.filter(t => tagNames.includes(t.name)).length > 0);
  }, [partnerData, projectDetail]);
  useEffect(() => {
    const searchStr = searchPartner?.trim() ?? '';
    const partners = suggestedPartners.length === 0 || searchStr ? partnerData : suggestedPartners;
    const newList = sortPartnersByNumberOfMatchedTags(partners, projectTags).sort((a, b) => {
      if (a.proposal_status === PartnerProposalStatus.PENDING) return -1;
      if (b.proposal_status === PartnerProposalStatus.PENDING) return 1;
      return 0;
    });
    setPartnerList(newList);
  }, [partnerData, projectDetail, searchPartner, suggestedPartners]);
  return <div className={styles.flexContainer}>
      <AbsoluteLoading isLoading={!!selectingPartner || loadingState} />
      {!isActivated && projectDetail.status_display !== PROJECT_STATUS_DISPLAY.MATCHED && <div className={styles.container}>
            <div className="search">
              <h1 className={styles.title}>Suggested Network Partner</h1>
              <Input.Search data-testid="suggested-partner-search" placeholder="Search Network Partners" value={searchPartner} onChange={value => updateSearchPartnerInput(value.target.value)} onSearch={handleSearchPartner} />
            </div>
            {loadingPartner ? <LoadingSpinner2 margin="150px" /> : <Row>
                <List locale={{
          emptyText: <Empty description="Nothing here yet" image={Empty.PRESENTED_IMAGE_SIMPLE} />
        }} itemLayout="horizontal" dataSource={partnerList} renderItem={partner => <PartnerCard partner={partner} project={projectDetail} selectPartner={(selectPartner, project) => handleSelectPartner(selectPartner, project)} unMatchPartner={(partnerId, projectId) => unMatchPartner(partnerId, projectId)} onClickName={openPartnerModal} />} />
              </Row>}
          </div>}
    </div>;
};
export default RightPane;